import { useTranslation } from 'react-i18next';

import { useAccountContext } from 'utils/account/AccountContext';
import { DAMAGE_INGESTION_V2 } from 'utils/release-toggles';

export const EXTERNAL_REFERENCE_MAX_LENGTH = 255;

export const isExternalReferenceTooLong = (value: string | null | undefined) =>
  (value ?? '').trim().length > EXTERNAL_REFERENCE_MAX_LENGTH;

export type ExternalReferenceObservation = {
  externalId?: string | null;
  externalIdSource?: string | null;
};

export type ExternalReferenceRow = {
  key: 'externalId' | 'externalIdSource';
  label: string;
  value: string;
};

export const useExternalReferenceRows = (
  observation: ExternalReferenceObservation | null | undefined
): ExternalReferenceRow[] => {
  const { t } = useTranslation();
  const { hasReleaseToggle } = useAccountContext();

  if (!hasReleaseToggle(DAMAGE_INGESTION_V2)) {
    return [];
  }

  const rows: ExternalReferenceRow[] = [
    {
      key: 'externalId',
      label: t('damage.externalId', 'External Id'),
      value: observation?.externalId ?? '',
    },
    {
      key: 'externalIdSource',
      label: t('damage.externalIdSource', 'External Id Source'),
      value: observation?.externalIdSource ?? '',
    },
  ];

  return rows.filter(({ value }) => value.trim() !== '');
};
